import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { FormControl } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import PropTypes from "prop-types";
import dayjs from "dayjs";

const DatePickerField = ({ name, label, required, disabled, ...rest }) => {
  const { control } = useFormContext();

  return (
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Controller
          name={name}
          control={control}
          render={({ field, fieldState }) => {
            const dayjsValue = field.value ? dayjs(field.value) : null;

            return (
              <FormControl fullWidth error={!!fieldState.error}>
              <DatePicker
                label={label}
                value={dayjsValue}
                disabled={disabled}
                onChange={(date) => {
                  const isoDate = date ? date.toISOString() : null;
                  field.onChange(isoDate);
                }}
                slotProps={{
                  textField: {
                    fullWidth: true,
                    required: required,
                    error: !!fieldState.error,
                    helperText: fieldState.error?.message,
                  },
                }}
                {...rest}
              />
              </FormControl>
            );
          }}
        />
      </LocalizationProvider>
  );
};

DatePickerField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default DatePickerField;
